<template>
  <div class="wrapper">
    <div class="sidemenu">
      <template v-if="dataList.length == 0">
      <div class="profile" @click="editUser">
        <div class="container">
          <Icon class="user-icon" :fill="'#fff'" :width="'55px'" :height="'55px'" :name="'user'"/>
          <div class="details">
            <template v-if="token">
              <p class="username">{{userinfo.name}}</p>
              <a>Edit Profile</a>
            </template>
            <template v-else>
              <p class="username">Login</p>
            </template>
          </div>
        </div>
      </div>
      <div class="category">
        <p class="label">Category</p>
        <div class="opt" @click="openOpt('cat')">
          <p>{{homeTitle}}</p>
          <Icon class="arrow" :fill="'#353f43'" :width="'55px'" :height="'55px'" :name="'arr-right'"/>
        </div>
      </div>
      <div class="brand">
        <p class="label">Brand</p>
        <div class="opt" @click="openOpt('brn')">
          <p>{{cbrand || 'All'}}</p>
          <Icon class="arrow" :fill="'#353f43'" :width="'55px'" :height="'55px'" :name="'arr-right'"/>
        </div>
      </div>
      <div class="product">
        <p class="label">Product</p>
        <div class="opt" @click="openOpt('prd')">
          <p>{{cprod || 'All'}}</p>
          <Icon class="arrow" :fill="'#353f43'" :width="'55px'" :height="'55px'" :name="'arr-right'"/>
        </div>
      </div>
      </template>
      <template v-else>
        <div class="headbar">
          <div @click="closeOpt">
            <Icon class="arrow" :fill="'#fff'" :width="'35px'" :height="'35px'" :name="'arr-left'"/>
          </div>
            <p class="title">Select Category</p>
        </div>
        <div class="listbox">
          <div class="list" :class="{active: !cOpt && !cprod && !cbrand}" @click="selectOpt(null)">
            <p>All</p>
          </div>
          <div class="list" v-for="(data, index) in dataList" :key="index" :class="{active: cOpt == data.cname || cprod == data.cname || cbrand == data.cname}" @click="selectOpt(data.cid, data.cname)">
            <p>{{data.cname}}</p>
          </div>
        </div>
      </template>
    </div>

    <svg display="none">
      <symbol
        width="10px"
        height="10px"
        viewBox="0 0 50 50"
        id="back"
        style="enable-background:new 0 0 50 50;"
      >
        <polygon points="50,3.3 25,46.7 0,3.3 " />
      </symbol>
      <symbol
        width="15px"
        height="15px"
        viewBox="0 0 50 50"
        id="drop"
        style="enable-background:new 0 0 50 50;"
      >
        <polygon points="50,3.3 25,46.7 0,3.3 " />
      </symbol>
    </svg>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import MoreMenu from '@/components/MoreMenu'
import Icon from '@/components/Reusables/Icon'
import {GetProductList} from '@/api/index.js'
export default {
  data() {
    return {
      opt: '',
      dataList: [],
      catList:[
        {cname: `Network Equipment`, cid:'1'},
        {cname: `Mining Accessories`, cid:'132'},
        {cname: `RFID`, cid:'133'},
      ],
      curCat: 1,
      cbrand: null,
      cprod: null,
      cOpt: null,
      userinfo: null,
      token: null
    };
  },
  // props: {
  // },
  components:{
    MoreMenu,
    Icon
  },
  computed:{
    // ...mapGetters('user',['getUserInfo','getToken']),
    bid(){
        return this.$store.state.product.bid
    },
    pid(){
        return this.$store.state.product.pid
    },
    homeTitle(){
        if(this.bid == '132'){
            return 'Mining Accessories'
        } else if(this.bid == '133'){
            return 'RFID'
        } else{
            return 'Network Equipment'
        }
    }
  },
  methods: {
    openOpt(p){
      this.opt = p
      if(p === 'cat'){
        this.dataList = this.catList
        return
      }
      this.initData()
    },
    closeOpt(){
      this.opt = ''
      this.dataList = []
    },
    selectOpt(p, n = null){
      if(this.opt == 'brn'){
        this.selectBrand(p, n)
      } else if (this.opt == 'prd'){
        this.selectProd(p, n)
      }

      this.goHome()
      this.cOpt = n
      if(this.opt == 'cat' && p != '1'){
        this.$store.commit('product/setBrand', p)
      } else{
        this.$store.commit('product/setBrand', null)
      }
    },

    initData(){
      GetProductList({'page_no':1,'sort_field':'price','sort':'asc','cid':null,'brand_id':this.bid,'keyword':null})
      .then(res =>{
          if(this.opt == 'brn'){
            this.dataList = res.data.brand_list;
          } else{
            this.dataList = res.data.category;
          }
      })
    },
    selectBrand(p, n = null){
        this.cbrand = n
        this.$store.commit('product/setBrand', p);

        this.cprod = null
        this.$store.commit('product/setProd', null);
    },
    selectProd(p, n = null){
        this.cprod = n
        this.$store.commit('product/setProd', p);
    },
    editUser(){
      // if(!this.token && !this.userinfo){
      if(!this.token){
        this.$store.commit('setCred', 'login')
        this.$emit('close');
        return
      }
      this.$emit('close');
      this.$store.commit('setEditUser', true);
    },
    goHome(){
      if(this.$route.name != 'home'){
          this.$router.push('/network')
      }
    }
  },
  created() {},
  mounted(){
    this.userinfo = this.$store.getters["user/getUserInfo"];
    this.token = this.$store.getters["user/getToken"];
  }
};
</script>

<style scoped>
.sidemenu {
  width: 300px;
  height: calc(100vh - env(safe-area-inset-bottom));
  padding-bottom: env(safe-area-inset-bottom);
  background: #353f43;
  position: absolute;
  z-index: 4;
  top: 0;
  left: 0;
  color: #fff;
}
.profile{
  width: 100%;
  height: 100px;
  /* background:darkslategray; */
  position: relative;
  margin-bottom: 20px;
  box-shadow: 0 5px 6px rgba(0,0,0,0.16);
}
.profile .container{
  position: absolute;
  top:50%;
  left: 50%;
  white-space: nowrap;
  transform: translate(-50%, -50%);
}
.user-icon, .details{
  display: inline-block;
  vertical-align: middle;
}
.user-icon{
  margin-right: 15px;
}
.username{
  font-weight: bold;
  font-size: 24px;
}

.label{
  margin-left: 20px;
  font-size: 20px;
  margin-bottom: 10px;
}
.opt{
  width: 100%;
  height: 100px;
  background: #C4CCCE;
  position: relative;
  margin-bottom: 25px;
  box-shadow: 0 5px 6px rgba(0,0,0,0.16);
}
.opt p, .opt .arrow{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.opt p{
  left: 20px;
  width: 60%;

  color: #353f43;
  font-size: 25px;
  font-weight: bold;
}
.opt .arrow{
  right: 20px;
}

.headbar{
  /* background: darkslategrey; */
  width: 100%;
  height: 50px;
  position: relative;
}
.headbar .arrow, .title{
  position: absolute;
  top:50%;
  transform: translateY(-50%);
}
.headbar .arrow{
  left: 5px;
  /* background: cornflowerblue; */
}
.title{
  left: calc(5px + 35px + 10px);
  font-size: 20px;
}
.listbox{
  width: 100%;
  height: calc(100vh - 50px);
  overflow-y: auto;
  background: #C4CCCE;
  color: #353f43;
}
.list{
  width: 100%;
  height: 88px;
  position: relative;
  border-bottom: 1px solid #869193;
}
.list:last-child{
  border: none;
}
.listbox .active{
  background: #869193;
}
.list p{
  position: absolute;
  top:50%;
  left: 20px;
  transform: translateY(-50%);
  font-size: 22px;
}
</style>


// WEBPACK FOOTER //
// src/components/SideMenu.vue